import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { API_ERROR_500 } from "../../../../config";
import { getStageScreen, setLoading } from "../../../../redux";
import Button from "../../components/Button";
import Title from "../../components/Title";
import { showPrevBtnByUrl, showNextBtnByUrl, getPrevAndNextRoute } from "utils";

const DDPI = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);

  const getApiUrl = () => {
    const url = window.sessionStorage.getItem("portal_domain");
    return url ? url.substring(0, url?.length - 1) : "";
  };

  const Api_Url = getApiUrl();

  const isInputDisabled = () => {
    return (
      Api_Url === "https://scmcbrkf.in" ||
      Api_Url === "https://saaketa.brkscmcj.in"
    );
  };

  const [formValue, setFormValue] = useState({
    ddpi_question_1: 0,
    ddpi_question_2: 0,
    ddpi_question_3: 0,
    ddpi_question_4: 0,
  });

  useEffect(() => {
    const Api_Url = getApiUrl();
    if (
      Api_Url === "https://scmcbrkf.in" ||
      Api_Url == "https://saaketa.brkscmcj.in"
    ) {
      setFormValue({
        ddpi_question_1: 1,
        ddpi_question_2: 1,
        ddpi_question_3: 1,
        ddpi_question_4: 1,
      });
    }
  }, []);

  const handleChange = (event) => {
    const { name, checked } = event.target;
    setFormValue({
      ...formValue,
      [name]: checked ? 1 : 0,
    });
  };

  const submitDDPI = () => {
    dispatch(setLoading(true));
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = portal_domain
      ? portal_domain.substring(0, portal_domain.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    console.log(formValue);
    axios
      .post(
        `${API_URL}/api/method/kyc_customizations.apis.ddpi_details.api.update_ddpi_details`,
        formValue,
        headers
      )
      .then(() => {
        toast.success("DDPI details saved successfully.");
        dispatch(getStageScreen());
        dispatch(setLoading(false));
      })
      .catch((error) => {
        const { response } = error;
        if (response?.data?.message) {
          toast.error(response?.data?.message);
        } else {
          toast.error(API_ERROR_500);
        }
        dispatch(setLoading(false));
      });

    // toast.success("Personal Data Verification Successful");
    //       dispatch(getStageScreen());
    //       dispatch(setLoading(false));
  };

  return (
    <React.Fragment>
      <Title title="(DDPI) Demat Debit and Pledge Instruction" />
      <div className="row">
        <div className="col-md-10">
          <div className="form-group">
            <div className="mb-2">
              <input
                name="ddpi_question_1"
                type="checkbox"
                onChange={(e) => handleChange(e)}
                value={formValue.ddpi_question_1}
                checked={formValue.ddpi_question_1 === 1}
                disabled={isInputDisabled()}
                style={{ cursor: "pointer" }}
              />
              <span style={{ marginLeft: "10px" }}>
                Transfer of securities held in the beneficial owner accounts of
                the client towards Stock Exchange related deliveries /
                settlement obligations arising out of trades executed by clients
                on the Stock Exchange through the same stock broker.
              </span>
            </div>
            <div className="mb-3">
              <input
                name="ddpi_question_2"
                type="checkbox"
                onChange={(e) => handleChange(e)}
                value={formValue.ddpi_question_2}
                checked={formValue.ddpi_question_2 === 1}
                disabled={isInputDisabled()}
                style={{ cursor: "pointer" }}
              />
              <span style={{ marginLeft: "10px" }}>
                Pledging / re-pledging of securities in favour of trading member
                (TM) / clearing member (CM) for the purpose of meeting margin
                requirements of the clients in connection with the trades
                executed by the clients on the Stock Exchange.
              </span>
            </div>
            <div className="mb-3">
              <input
                name="ddpi_question_3"
                type="checkbox"
                onChange={(e) => handleChange(e)}
                value={formValue.ddpi_question_3}
                checked={formValue.ddpi_question_3}
                disabled={isInputDisabled()}
                style={{ cursor: "pointer" }}
              />
              <span style={{ marginLeft: "10px" }}>
                Mutual Fund transactions being executed on Stock Exchange order
                entry platforms.
              </span>
            </div>
            <div className="mb-3">
              <input
                name="ddpi_question_4"
                type="checkbox"
                onChange={(e) => handleChange(e)}
                value={formValue.ddpi_question_4}
                checked={formValue.ddpi_question_4}
                disabled={isInputDisabled()}
                style={{ cursor: "pointer" }}
              />
              <span style={{ marginLeft: "10px" }}>
                Tendering shares in open offers through Stock Exchange
                platforms.
              </span>
            </div>
            <div className="d-flex mb-3">
              {showPrevBtnByUrl(
                history.location.pathname,
                kycStatus,
                kycPageName
              ) && (
                <Button
                  title="Previous"
                  type="button"
                  className="mx-1"
                  handleClick={() => {
                    const route = getPrevAndNextRoute(
                      history.location.pathname.slice(1),
                      kycPageName
                    );
                    history.push(route.prev);
                  }}
                />
              )}
              <Button
                title="Submit"
                type="button"
                name="Submit"
                className="mx-1"
                handleClick={submitDDPI}
              />
              {showNextBtnByUrl(
                history.location.pathname,
                kycStatus,
                kycPageName
              ) && (
                <Button
                  title="Next"
                  type="button"
                  className="mx-1"
                  handleClick={() => {
                    const route = getPrevAndNextRoute(
                      history.location.pathname.slice(1),
                      kycPageName
                    );
                    history.push(route.next);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DDPI;
